export const POPULAR_CURRENCIES = 'popular_currencies';
export const MORE_CURRENCIES = 'more_currencies';
export const LANGUAGE = 'LANGUAGE';
export const CURRENCY = 'CURRENCY';
